import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Swiper from '../../components/Swiper';
import { Button, Col, Container, Row } from 'reactstrap';
import Image from "next/image";
import { getImageUrl } from "../../services/image";
import 'swiper/css/swiper.css';
import Head from "next/head";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Index = function Index(_ref) {
  var data = _ref.data;
  // const [data, setData] = useState({});
  var router = useRouter();
  var index = router.query.index; // import(`../../data/vakantiehuizen-ervaar/${index}`).then(data => setData(data.default));

  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsxs("title", {
        children: [data.title && data.title, " - Cottage Centre Vakantiehuizen en Campers"]
      }), /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: "Cottages ".concat(data.title)
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: "hero py-6 py-lg-7 text-white dark-overlay",
      children: [data.hero && /*#__PURE__*/_jsx(Image, {
        src: getImageUrl(data.hero),
        className: "bg-image",
        alt: "",
        layout: "fill",
        objectFit: "cover"
      }), /*#__PURE__*/_jsx(Container, {
        className: "overlay-content",
        children: /*#__PURE__*/_jsx("h1", {
          className: "hero-heading",
          children: data.title && data.title
        })
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: "py-3",
      children: /*#__PURE__*/_jsxs(Container, {
        fluid: true,
        children: [/*#__PURE__*/_jsx(Row, {
          className: "",
          children: /*#__PURE__*/_jsx(Col, {
            xl: "10",
            lg: "10",
            className: "mx-auto",
            children: /*#__PURE__*/_jsxs("blockquote", {
              className: "blockquote blockquote-primary bg-gray-100 p-5",
              children: [/*#__PURE__*/_jsx("p", {
                className: "first-line",
                dangerouslySetInnerHTML: {
                  __html: data['intro-oneliner']
                }
              }), /*#__PURE__*/_jsx("p", {
                dangerouslySetInnerHTML: {
                  __html: data['intro-text']
                }
              }), /*#__PURE__*/_jsx("ul", {
                children: data.subjects && data.subjects.map(function (subject, index) {
                  return /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(Link, {
                      href: "/vakantiehuizen-ervaar/".concat(router.query.index, "#subject_").concat(index),
                      scroll: false,
                      children: subject.title
                    })
                  }, index);
                })
              })]
            })
          })
        }), data.subjects && data.subjects.map(function (subject, index) {
          return /*#__PURE__*/_jsxs(Row, {
            className: "py-2",
            children: [/*#__PURE__*/_jsx("a", {
              "aria-label": subject.title,
              href: "/vakantiehuizen-ervaar/".concat(router.query.index, "#subject_").concat(index),
              className: "anchor",
              id: "subject_".concat(index)
            }), /*#__PURE__*/_jsxs(Col, {
              xl: "10",
              lg: "10",
              className: "mx-auto",
              children: [/*#__PURE__*/_jsx("h3", {
                children: subject.title
              }), /*#__PURE__*/_jsx("div", {
                className: "text-content pb-3",
                dangerouslySetInnerHTML: {
                  __html: subject.content
                }
              }), /*#__PURE__*/_jsx("div", {
                className: "d-md-flex align-items-center justify-content-end",
                children: /*#__PURE__*/_jsx(Link, {
                  href: subject.buttonLink,
                  children: /*#__PURE__*/_jsxs(Button, {
                    size: "sm",
                    color: "link",
                    children: [subject.button, /*#__PURE__*/_jsx("i", {
                      className: "fas fa-angle-double-right ml-2"
                    })]
                  })
                })
              }), subject.featured && /*#__PURE__*/_jsx(Swiper, {
                className: "items-slider-full px-lg-5 pt-3 pb-5",
                perView: 1,
                spaceBetween: 20,
                roundLengths: true,
                md: 2,
                lg: 3,
                xl: 3,
                xxl: 4,
                xxxl: 4,
                data: subject.featured.swiper,
                placeCards: true,
                navigation: true
              })]
            })]
          }, index);
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default Index;